import { render, staticRenderFns } from "./TrainStation.vue?vue&type=template&id=4de5d226&"
import script from "./TrainStation.vue?vue&type=script&lang=ts&"
export * from "./TrainStation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports